export function OutlineFileKmlIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7955 21.0004V15.002L12.3049 20.1654L9.79517 15.002V21.0004"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 15.002V21.0004"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.4407 15.002L3 19.6232"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.79575 21.0007L4.64111 17.416"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7947 15.002V21.0004H20.7939"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8261 12.0025V8.83048C18.8261 8.29782 18.615 7.79395 18.2407 7.41485L14.4113 3.58545C14.037 3.21115 13.5283 3 12.9956 3H6.76207C5.65835 3 4.76099 3.89737 4.76099 5.00108V11.9977"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M12.8276 3.00391V7.28919C12.8276 8.23454 13.5954 9.00234 14.5408 9.00234H18.8261"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
